
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/nfts/activity",
      function () {
        return require("private-next-pages/nfts/activity.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/nfts/activity"])
      });
    }
  